import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { TransportInvoiceDetailModel } from 'src/app/models/additional/transport-invoice-detail.model';
import { TransportInvoiceDetailService } from 'src/app/services/additional/transport-invoice-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-transport-invoice-detail',
  templateUrl: './register-transport-invoice-detail.component.html',
  styleUrls: ['./register-transport-invoice-detail.component.scss'],
  standalone: false
})
export class RegisterTransportInvoiceDetailComponent implements OnInit, OnChanges {

  @Input() transportInvoiceId: number = 0;
  @Input() transportInvoiceDetail: TransportInvoiceDetailModel = new TransportInvoiceDetailModel();
  @Input() permissionUpdatable: boolean = false;
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<void>();

  formDetail: FormGroup = new FormGroup({});

  constructor(
    private formBuilder: FormBuilder,
    private transportInvoiceDetailService: TransportInvoiceDetailService,
    private toastHandlerService: ToastHandlerService
  ) {
    this.validateForm(new TransportInvoiceDetailModel());
  }

  ngOnInit(): void {
    this.validateForm(this.transportInvoiceDetail);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const detailChange = changes['transportInvoiceDetail'];
    if (detailChange && detailChange.currentValue) {
      this.validateForm(detailChange.currentValue);
    }
  }

  validateForm(detail: TransportInvoiceDetailModel) {
    this.formDetail = this.formBuilder.group({
      document: [{ value: detail.document, disabled: true }],
      consecutive: [{ value: detail.consecutive, disabled: true }],
      transportValuePay: [{ value: detail.transportValuePay, disabled: true }],
      transportValueInvoiced: [detail.transportValueInvoiced, [Validators.required, Validators.min(0)]]
    });
  }

  cancel() {
    this.isFormView.emit(false);
  }

  async save() {
    if (this.formDetail.valid) {
      const rawValue = this.formDetail.getRawValue();
      const updatedDetail: TransportInvoiceDetailModel = {
        ...this.transportInvoiceDetail,
        transportValueInvoiced: rawValue.transportValueInvoiced
      };
      try {
        await firstValueFrom(this.transportInvoiceDetailService.updateDetail(this.transportInvoiceId, updatedDetail));
        this.toastHandlerService.showToast('success', 'El detalle de la factura de transporte fue actualizado exitosamente.');
        this.updateListDetail.emit();
        this.validateForm(new TransportInvoiceDetailModel());
      } catch (error) {
        console.error('Error al actualizar el detalle de la factura de transporte.', error);
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Revise los campos obligatorios del detalle.');
    }
  }
}
